import React from "react";
import { Business, Apartment, FreeBreakfast, Hotel } from "@material-ui/icons";
import { Typography } from "@material-ui/core";
import { ToggleButtonGroup } from "@components/formx";

type Props = {
  name: string;
};

export function AccommodationTypeField(props: Props) {
  return (
    <ToggleButtonGroup
      exclusive={false}
      name={props.name}
      options={[
        {
          value: "house",
          label: (
            <div style={cellStyle}>
              <Apartment />
              <Typography variant="caption">Lgh/Hus</Typography>
            </div>
          )
        },
        {
          value: "hotel",
          label: (
            <div style={cellStyle}>
              <Hotel />
              <Typography variant="caption">Hotel</Typography>
            </div>
          )
        },
        {
          value: "bedAndBreakfast",
          label: (
            <div style={cellStyle}>
              <FreeBreakfast />
              <Typography variant="caption">Vandrarhem</Typography>
            </div>
          )
        },
        {
          value: "optional",
          label: (
            <div style={cellStyle}>
              <Business />
              <Typography variant="caption">Valfri</Typography>
            </div>
          )
        }
      ]}
      hideErrorLabel
    />
  );
}

const cellStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center"
} as React.CSSProperties;
